import { h } from 'preact'
import { Banniere } from '../banniere/banniere.jsx'

export const JeuxVideo = ({ title, URL, images, alt, analytics, cacheKey }) => {
   let props = {
      tag: '',
      date: '',
      title: '',
      description: '',
      legals: '',
      legalNotice: {
         title: '',
         content: '',
         showButtonLabel: '',
         background : '', 
         index: 0
      },
      images: images,
      URL: URL,
      textColor: 'white',
      analytics: analytics,
      cacheKey: cacheKey,
      alt: alt,
      index: 0,
      context: '310px',
   }
   return (
      <div data-testid="bande-jeux-video" data-cache-key={cacheKey}>
         <div class="container-fluid pt-2">
            <div class="row">
               <div class="col-12">
                  <h2>{title}</h2>
               </div>
            </div>
         </div>
         <div class="row no-gutters">
            <div class="col-12 jeux-video-310px">
               <Banniere {...props} />
            </div>
         </div>
      </div>
   )
}
